import Model from "../classes/model/Model";
import User from "./User";
import qs from "qs";
import ValidationError from "../classes/ValidationError";

/**
 * @property {int} id
 * @property {string} name
 *
 * @property {int} created_by
 * @property {int} updated_by
 * @property {int} created_at
 * @property {int} updated_at
 *
 * @property {User} creator
 * @property {User} updater
 */
export default class UserPost extends Model {

    relations() {
        return {
            creator: {class: User, many: false},
            updater: {class: User, many: false},
        };
    }

    static getList(filter = {}, page = 1, sort = undefined, perPage = 25,  extraFields = []) {

        return UserPost.getAxios().get(UserPost.getUrl('user-post/list'), {
            params: {
                page: page,
                'per-page': perPage,
                filter: filter,
                sort: sort,
                expand: extraFields.length > 0 ? extraFields.join(',') : undefined,
            },
            paramsSerializer: params => qs.stringify(params),
        }).then((response) => {
            let data = [];
            for (let userPost of response.data) {
                data.push(new UserPost(userPost));
            }
            return {data, headers: response.headers};
        });
    }

    static getById(id, extraFields = []) {

        return this.getAxios().get(this.getUrl('user-post/get-by-id'), {
            params: {
                id: id,
                expand: extraFields.length > 0 ? extraFields.join(',') : undefined,
            },
        }).then(({data}) => {
            return new UserPost(data);
        });
    }

    create() {
        return UserPost.getAxios().post(this.getUrl('user-post/create'), this.getValues()).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            this.id = data.id;
            return true;
        });
    }

    update() {
        if (!this.id) {
            throw new Error('id not set');
        }

        return UserPost.getAxios().post(this.getUrl('user-post/update'), this.getValues()).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        })
    }

}
